import React, { useEffect } from 'react';
import { CSVLink } from 'react-csv';
import Accordion from '../../components/Accordion/Accordion';
import Input from '../../components/Input/Input';
import { apiCall } from '../../APICalls/APICalls';
import { useSelector, useDispatch } from 'react-redux';
import {
    approveIcon,
    denyIcon,
    cautionIcon,
    suggestionIcon,
    printIcon,
    exportIcon,
    uploadIcon,
    createIcon
} from '../../assets/Icons/Icons';
import {
    selectModificationCategories,
    selectModification,
    setModification,
    setUnsavedDenialReason,
    selectUnsavedDenialReason,
    setApproveOnBehalf,
    selectApproveOnBehalf,
    hasUnfinishedFlags,
    setUnfinishedAuthUpload,
    selectUnfinishedAuthUpload,
    createTimeStamp,
    setLoadingStatus,
    selectLoadingStatus,
    generateNotificationObj,
    filterQuoteObjectsByInputDate,
    updateQuotesArray,
    updateNotificationsArray,
    getAllNotifications,
    formatCustomerNumber,
    openQuoteRevision
} from '../../store/quotesAndNotificationsSlice';
import {
    setSidePanelTitle,
    setCurrentPage
} from '../../store/pageLayoutSlice';
import './Quotes.css';

function actionsMessage(status){
    let message;
    switch(status){
        case 'denied':
        case 'approved with change':
            message = 'A revision with the specified changes must be completed for this quote to be approved.';
        break;
        default:
            message = 'There are currently no actions that can be taken for this quote.';
    }
    return message;
}

function prepareQuoteFilterData(quoteFilters, view, userId){
    let filterData;
    if( view === 'quotes' ){
        let _status = quoteFilters.previous.status.trim();
        let _customerNumber = quoteFilters.previous.customerNumber.trim();
        filterData = { customerNumber: _customerNumber, status: _status };
        //filterData = { customerNumber: '', status: '' };
    } else {
        let _type = quoteFilters.previous.type.trim();
        let _status = quoteFilters.previous.status.trim();
        filterData = { userId: userId.toString(), type: _type, status: _status };
    }
    return filterData;
}

function getFreshQuotes(quoteFilters, view, userId){
    const apiData = prepareQuoteFilterData(quoteFilters, view, userId);
    if( view === 'quotes' ){
        if( apiData.customerNumber === '' && apiData.status === '' ){
            return apiCall('quotesAndNotifications/getAllQuotes');
        } else if( apiData.customerNumber !== '' && apiData.status !== '' ) {
            return apiCall('quotesAndNotifications/getQuotes', apiData);
        }
    } else {
        if( apiData.type !== '' && apiData.status !== '' ){
            return apiCall('quotesAndNotifications/getNotifications', apiData);
        } else if( apiData.status !== '' ){
            return apiCall('quotesAndNotifications/getAllNotifications', apiData)
        }
    }
}

function CsvDownload(props){
    const quoteObj = props.activeQuote.quote[0];
    const { standardItems, miscellaneousItems } = quoteObj.productInformation;
    const { machinesAndTools } = quoteObj;
    const { generalDetails, customerInformation, activationDuration } = quoteObj.generalInformation
    const csvArray = [
        [ "Quote Number", "Opportunity Number", "Customer Number", "Customer", "Activation Date", "Expiration Date", "Estimated Total Value", "Subject" ],
        [ props.activeQuote.quoteNumber, generalDetails.opportunityNumber, customerInformation.customerNumber, customerInformation.customer, activationDuration.activationDate, activationDuration.expirationDate, generalDetails.estimatedTotalValue, generalDetails.quoteSubject],
    ];

    if( standardItems.length > 0 ){
        csvArray.push([ " ", " ", " ", " ", " " ]);
        csvArray.push([ "Product Description", "Hierarchy", "Standard Discount", "Discount", "Percentage" ]);
        standardItems.forEach( item => {
            // let hierarchies = item.productHierarchies[0];
            for( let i = 0; i < item.productHierarchies.length; i++ ){
                //hierarchies += " | " + item.productHierarchies[i];
                csvArray.push([ item.productDescription, item.productHierarchies[i], item.stdDiscount, item.discount, item.percentage ]);
            }
            // csvArray.push([ item.productDescription, hierarchies, item.stdDiscount, item.discount, item.percentage ]);
        });
    }

    if( miscellaneousItems.length > 0 ){
        csvArray.push([ " ", " ", " "]);
        csvArray.push(["Product Description", "Total % off", "Net Pricing"]);
        miscellaneousItems.forEach( item => {
            let percentOff = item.totalPercentOff === '' ? item.totalPercentOff : item.totalPercentOff.replace(/%/g, '') + '%';
            let netPricing = item.netPricing === '' ? item.netPricing : ('$' + item.netPricing);
            csvArray.push([item.productDescription, percentOff, netPricing]);
        });
    }

    if( machinesAndTools.length > 0 ){
        csvArray.push([ " ", " "]);
        csvArray.push(["Machine Description", "Rental Duration"]);
        machinesAndTools.forEach( machine => {
            csvArray.push([machine.machineDescription, machine.rentalDuration]);
        });
    }

    return (
        <CSVLink
            data={ csvArray }
            filename={ props.activeQuote.quoteNumber + "-" + quoteObj.timestamp.replace(/\//g, '-') + ".csv" }
            className="quote_action_button csv_download_link"
            target="_blank"
        >
            {exportIcon}
            <span className="quote_action_button_text">Export Quote</span>
        </CSVLink>
    );
}

function getFlagStatuses(flagArray){
    let pendingFlag = false, approvedWithChangeFlag = false, deniedFlag = false;
    flagArray.forEach( flag =>{
        if( flag.status ){
            let flagStatus = flag.status.toLowerCase();
            if( flagStatus === 'pending' ){
                pendingFlag = true;
            } else if( flagStatus === 'denied' ){
                deniedFlag = true;
            } else if( flagStatus === 'approved with change'){
                approvedWithChangeFlag = true;
            }
        }
    });
    return {
        pendingFlag: pendingFlag,
        approvedWithChangeFlag: approvedWithChangeFlag,
        deniedFlag: deniedFlag
    };
}

function updateNotifications(status, notifications){
    let _status = status.toLowerCase();
    if( _status !== 'pending' ){
        notifications.forEach( notification => {
            let type = notification.Type.toLowerCase();
            if( type !== 'message' && type !== _status ){ //message notifications aren't notifications dealing with status, ignore them
                notification.Type = status; //change notification type to the status type. This is assuming reuse of notifications within a specific revision
                notification.status = 'Unread'; //set it to Unread so it shows up in notifications
                //create email notification here.
            }
        });
    }
}

function Actions(props){

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch( setSidePanelTitle('Actions') )
    }, [ dispatch ]);

    const {
        canSuggest,
        canApprove,
        canApproveOnBehalf,
        canPrint,
        canExport,
        canRevise,
        flags,
        activeQuote,
        quoteFilters,
        credentials,
        view,
        activeQuoteInfo,
        quoteStatus
    } = props;

    //console.log(flags);

    const categories = useSelector( selectModificationCategories );
    const modification = useSelector( selectModification );
    const denialReason = useSelector( selectUnsavedDenialReason );
    const approveOnBehalfData = useSelector( selectApproveOnBehalf );
    const unfinishedAuthUpload = useSelector( selectUnfinishedAuthUpload );
    const loadingStatus = useSelector( selectLoadingStatus );

    const filteredFlags = flags.filter( flag => flag.status.toLowerCase() === "pending" );
    console.log(filteredFlags);
    const pendingFlags = flags.filter( flag => flag.status.toLowerCase() === "pending" );
    const approvedFlags = flags.filter( flag => flag.status.toLowerCase().includes("approved") );
    const {
        unfinishedFlags,
        unfinishedFlagsArray
    } = hasUnfinishedFlags(flags, credentials);

    const handleApproveOnBehalf = (e, field, data) =>{ //selecting flags and uploading files
        let dataObj = { field: field, value: data };
        dispatch( setApproveOnBehalf( dataObj ) );
    };

    const handleUnfinishedFlags = (actionType, data) =>{
        let dataObj = { actionType: actionType, value: data };
        dispatch( setUnfinishedAuthUpload( dataObj ) );
    }

    const approveOnBehalf = () =>{
        if( approveOnBehalfData.flags.length > 0 ){
            dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: 'loading'} ) );
            apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( res => {
                //getFreshQuotes(quoteFilters, view, credentials.userId).then( res => { //get latest quote data to help ensure data integrity
                //let quoteObjArr = filterQuoteObjectsByInputDate( res.data );
                //const freshQuote = quoteObjArr.find( quote => quote.quoteId === activeQuote.quoteId );
                const freshQuote = filterQuoteObjectsByInputDate( res.data )[0];
                if( freshQuote ){
                    const revision = freshQuote.quote.find( rev => rev.revisionNumber === activeQuoteInfo.revisionNumber );
                    if( revision ){
                        const fileInputObjects = approveOnBehalfData.files.map(file => { //get input elements
                            return (
                                {
                                    id: file.id, //id is the flagId, fileId is the input element id
                                    element: document.getElementById(file.fileId),
                                    url: ''
                                }
                            );
                        });

                        if( fileInputObjects.length > 0 ){ // if there are files, upload them
                            const fileUploadRequests = fileInputObjects.map( inputObj => { //create api calls for the objects
                                let formData = new FormData();
                                formData.append('uploadBlob', inputObj.element.files[0]);
                                const uploadData = {
                                    uploadData: formData
                                };
                                return (
                                    apiCall('quotesAndNotifications/authorizationUpload', uploadData)
                                    //apiCall('quotesAndNotifications/authorizationUpload', formData)
                                );
                            });
                            Promise.all( fileUploadRequests ).then( responses => {
                                responses.forEach( (res, i) => {
                                    if( res.data.success ){
                                        fileInputObjects[i].url = res.data.url;
                                    } else {
                                        fileInputObjects[i].url = 'ERROR';
                                    }
                                });

                                approveOnBehalfData.flags.forEach( flag => { //loop through flags selected for approval
                                    let approvedFlag = revision.flags.find( revFlag => revFlag.id === flag.id ); //get actual flag object in quote
                                    if( approvedFlag && approvedFlag.status.toLowerCase() === 'pending' ){
                                        approvedFlag.status = 'Approved';
                                        approvedFlag.approvedBy.userName = credentials.userName;
                                        approvedFlag.approvedBy.date = createTimeStamp();
                                        approvedFlag.approvedBy.role = credentials.userType.role;
                                        let uploadObj = fileInputObjects.find( inputObj => inputObj.id === flag.id );
                                        if( uploadObj ){
                                            approvedFlag.approvedBy.proofOfAuthorization = uploadObj.url;
                                        }
                                    }
                                });
                                const {
                                    deniedFlag,
                                    approvedWithChangeFlag,
                                    pendingFlag
                                } = getFlagStatuses(revision.flags);

                                if( deniedFlag ){
                                    revision.status = 'Denied';
                                } else if( pendingFlag ) {
                                    revision.status = 'Pending';
                                } else if( approvedWithChangeFlag ){
                                    revision.status = 'Approved With Change';
                                } else {
                                    revision.status = 'Approved';
                                }

                                updateNotifications(revision.status, revision.notifications);
                                apiCall('quotesAndNotifications/putQuote', freshQuote).then( res => { //change to dispatch and replace updated quote in state
                                    if( res.data ){
                                        const apiFetchData = prepareQuoteFilterData(quoteFilters, view, credentials.userId);
                                        if( view === 'quotes' ){
                                            // Refetch the updated quote from server to ensure fresh data
                                            apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( refetchRes => {
                                                const refetchedQuote = filterQuoteObjectsByInputDate( refetchRes.data )[0];
                                                if( refetchedQuote ){
                                                    dispatch( updateQuotesArray( refetchedQuote ) );
                                                }
                                                dispatch( setApproveOnBehalf({field: 'clear_all' }) );
                                                dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                            }).catch(() => {
                                                dispatch( setApproveOnBehalf({field: 'clear_all' }) );
                                                dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                            });
                                        } else {
                                            //dispatch( getNotifications( apiFetchData ) );
                                            dispatch( getAllNotifications( apiFetchData ) ).then(() => {
                                                dispatch( setApproveOnBehalf({field: 'clear_all' }) );
                                                dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                            }).catch(() => {
                                                dispatch( setApproveOnBehalf({field: 'clear_all' }) );
                                                dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                            });
                                        }
                                    } else {
                                        dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                    }
                                }).catch(() => {
                                    dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                });

                            }).catch(e => {
                                console.log(e);
                                dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                            });

                        } else { //proceed with uploading flags
                            approveOnBehalfData.flags.forEach( flag => { //loop through flags selected for approval
                                let approvedFlag = revision.flags.find( revFlag => revFlag.id === flag.id ); //get actual flag object in quote
                                if( approvedFlag && approvedFlag.status.toLowerCase() === 'pending' ){
                                    approvedFlag.status = 'Approved';
                                    approvedFlag.approvedBy.userName = credentials.userName;
                                    approvedFlag.approvedBy.date = createTimeStamp();
                                    approvedFlag.approvedBy.role = credentials.userType.role;
                                }
                            });
                            const {
                                deniedFlag,
                                approvedWithChangeFlag,
                                pendingFlag
                            } = getFlagStatuses(revision.flags);

                            if( deniedFlag ){
                                revision.status = 'Denied';
                            } else if( pendingFlag ) {
                                revision.status = 'Pending';
                            } else if( approvedWithChangeFlag ){
                                revision.status = 'Approved With Change';
                            } else {
                                revision.status = 'Approved';
                            }

                            updateNotifications(revision.status, revision.notifications);
                            apiCall('quotesAndNotifications/putQuote', freshQuote).then( res => {
                                if( res.data ){
                                    const apiFetchData = prepareQuoteFilterData(quoteFilters, view, credentials.userId);
                                    if( view === 'quotes' ){
                                        // Refetch the updated quote from server to ensure fresh data
                                        apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( refetchRes => {
                                            const refetchedQuote = filterQuoteObjectsByInputDate( refetchRes.data )[0];
                                            if( refetchedQuote ){
                                                dispatch( updateQuotesArray( refetchedQuote ) );
                                            }
                                            dispatch( setApproveOnBehalf({field: 'clear_all' }) );
                                            dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                        }).catch(() => {
                                            dispatch( setApproveOnBehalf({field: 'clear_all' }) );
                                            dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                        });
                                    } else {
                                        //dispatch( getNotifications( apiFetchData ) );
                                        dispatch( getAllNotifications( apiFetchData ) ).then(() => {
                                            dispatch( setApproveOnBehalf({field: 'clear_all' }) );
                                            dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                        }).catch(() => {
                                            dispatch( setApproveOnBehalf({field: 'clear_all' }) );
                                            dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                        });
                                    }
                                } else {
                                    dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                                }
                            }).catch(() => {
                                dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
                            });
                        }
                    }
                }
            }).catch(e => {
                console.log(e);
                dispatch( setLoadingStatus( {field: 'approveOnBehalf', value: ''} ) );
            });
        }
    };

    const handleModificationChange = (e, field) =>{
        dispatch( setModification( { field: field, value: e.target.value } ) );
    };

    const denyQuote = () =>{
        dispatch( setLoadingStatus( {field: 'denyQuote', value: 'loading'} ) );
        apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( res => {
            //getFreshQuotes(quoteFilters, view, credentials.userId).then( res => { //get latest quote data to help ensure data integrity
            //let quoteObjArr = filterQuoteObjectsByInputDate( res.data );
            //const freshQuote = quoteObjArr.find( quote => quote.quoteId === activeQuote.quoteId );
            const freshQuote = filterQuoteObjectsByInputDate( res.data )[0];
            if( freshQuote ){
                const revision = freshQuote.quote.find( rev => rev.revisionNumber === activeQuoteInfo.revisionNumber );
                if( revision ){
                    revision.denialReason = denialReason;
                    revision.flags.forEach( flag =>{
                        if( flag.status && flag.status.toLowerCase() === 'pending' ){
                            let userObj = flag.chainOfCommand.find( command => command.userId === credentials.userId && command.role === credentials.userType.role );
                            if( userObj ){
                                flag.status = 'Denied';
                                flag.approvedBy.userName = userObj.userName;
                                flag.approvedBy.date = createTimeStamp();
                                flag.approvedBy.role = userObj.role;
                                revision.denialReason = denialReason;
                                revision.status = 'Denied';
                            }
                        }
                    });
                    //prepare emails here

                    updateNotifications(revision.status, revision.notifications);

                    apiCall('quotesAndNotifications/putQuote', freshQuote).then( res => {
                        if( res.data ){
                            const apiFetchData = prepareQuoteFilterData(quoteFilters, view, credentials.userId);
                            if( view === 'quotes' ){
                                // Refetch the updated quote from server to ensure fresh data
                                apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( refetchRes => {
                                    const refetchedQuote = filterQuoteObjectsByInputDate( refetchRes.data )[0];
                                    if( refetchedQuote ){
                                        dispatch( updateQuotesArray( refetchedQuote ) );
                                    }
                                    dispatch( setLoadingStatus( {field: 'denyQuote', value: ''} ) );
                                }).catch(() => {
                                    dispatch( setLoadingStatus( {field: 'denyQuote', value: ''} ) );
                                });
                            } else {
                                //dispatch( getNotifications( apiFetchData ) );
                                dispatch( getAllNotifications( apiFetchData ) ).then(() => {
                                    dispatch( setLoadingStatus( {field: 'denyQuote', value: ''} ) );
                                }).catch(() => {
                                    dispatch( setLoadingStatus( {field: 'denyQuote', value: ''} ) );
                                });
                            }
                        } else {
                            dispatch( setLoadingStatus( {field: 'denyQuote', value: ''} ) );
                        }
                    }).catch(() => {
                        dispatch( setLoadingStatus( {field: 'denyQuote', value: ''} ) );
                    });
                }
            }

        }).catch(e => {
            console.log(e);
            dispatch( setLoadingStatus( {field: 'denyQuote', value: ''} ) );
        });
    }

    const approveQuote = () =>{
        dispatch( setLoadingStatus( {field: 'approveQuote', value: 'loading'} ) );
        apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( res => {
            //getFreshQuotes(quoteFilters, view, credentials.userId).then( res => { //get latest quote data to help ensure data integrity
            //let quoteObjArr = filterQuoteObjectsByInputDate( res.data );
            //const freshQuote = quoteObjArr.find( quote => quote.quoteId === activeQuote.quoteId );
            const freshQuote = filterQuoteObjectsByInputDate( res.data )[0];
            if( freshQuote ){
                const revision = freshQuote.quote.find( rev => rev.revisionNumber === activeQuoteInfo.revisionNumber );
                if( revision ){
                    revision.flags.forEach( flag =>{
                        if( flag.status && flag.status.toLowerCase() === 'pending' ){
                            let userObj = flag.chainOfCommand.find( command => command.userId === credentials.userId && command.role === credentials.userType.role );
                            if( userObj ){
                                flag.status = 'Approved';
                                flag.approvedBy.userName = userObj.userName;
                                flag.approvedBy.date = createTimeStamp();
                                flag.approvedBy.role = userObj.role;
                            }
                        }
                    });

                    const {
                        deniedFlag,
                        approvedWithChangeFlag,
                        pendingFlag
                    } = getFlagStatuses(revision.flags);

                    if( !pendingFlag && !deniedFlag ){
                        if( approvedWithChangeFlag ){
                            revision.status = 'Approved With Change';
                        } else {
                            revision.status = 'Approved';
                        }
                        //prepare emails here
                        updateNotifications(revision.status, revision.notifications);
                    }

                    apiCall('quotesAndNotifications/putQuote', freshQuote).then( res => {
                        if( res.data ){
                            const apiFetchData = prepareQuoteFilterData(quoteFilters, view, credentials.userId);
                            if( view === 'quotes' ){
                                // Refetch the updated quote from server to ensure fresh data
                                apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( refetchRes => {
                                    const refetchedQuote = filterQuoteObjectsByInputDate( refetchRes.data )[0];
                                    if( refetchedQuote ){
                                        dispatch( updateQuotesArray( refetchedQuote ) );
                                    }
                                    dispatch( setLoadingStatus( {field: 'approveQuote', value: ''} ) );
                                }).catch(() => {
                                    dispatch( setLoadingStatus( {field: 'approveQuote', value: ''} ) );
                                });
                            } else {
                                //dispatch( getNotifications( apiFetchData ) );
                                dispatch( getAllNotifications( apiFetchData ) ).then(() => {
                                    dispatch( setLoadingStatus( {field: 'approveQuote', value: ''} ) );
                                }).catch(() => {
                                    dispatch( setLoadingStatus( {field: 'approveQuote', value: ''} ) );
                                });
                            }
                        } else {
                            dispatch( setLoadingStatus( {field: 'approveQuote', value: ''} ) );
                        }
                    }).catch(() => {
                        dispatch( setLoadingStatus( {field: 'approveQuote', value: ''} ) );
                    });
                }
            }
        }).catch(() => {
            dispatch( setLoadingStatus( {field: 'approveQuote', value: ''} ) );
        });
    }

    const approveWithChange = () =>{ //make sure all quoters get notified
        dispatch( setLoadingStatus( {field: 'approveWithChange', value: 'loading'} ) );
        const modificationObj = {
            userName: credentials.userName,
            categories: modification.categories,
            modification: modification.content,
            timestamp: createTimeStamp()
        };
        apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( res => {
            //getFreshQuotes(quoteFilters, view, credentials.userId).then( res => { //get latest quote data to help ensure data integrity
            //let quoteObjArr = filterQuoteObjectsByInputDate( res.data );
            //const freshQuote = quoteObjArr.find( quote => quote.quoteId === activeQuote.quoteId );
            const freshQuote = filterQuoteObjectsByInputDate( res.data )[0];
            if( freshQuote ){
                const revision = freshQuote.quote.find( rev => rev.revisionNumber === activeQuoteInfo.revisionNumber );
                if( revision ){
                    revision.flags.forEach( flag =>{
                        if( flag.status && flag.status.toLowerCase() === 'pending' ){
                            let userObj = flag.chainOfCommand.find( command => command.userId === credentials.userId && command.role === credentials.userType.role );
                            if( userObj ){
                                flag.status = 'Approved With Change';
                                flag.approvedBy.userName = credentials.userName;
                                flag.approvedBy.date = createTimeStamp();
                                flag.approvedBy.role = userObj.role;
                            }
                        }
                    });

                    const {
                        deniedFlag,
                        pendingFlag
                    } = getFlagStatuses(revision.flags);

                    if( !pendingFlag && !deniedFlag ){
                        revision.status = 'Approved With Change';
                        //prepare emails here

                        updateNotifications(revision.status, revision.notifications);
                    }

                    revision.modifications.push(modificationObj);

                    const userRoleData = {
                        app: "hdmi",
                        userType: "Quoter",
                        role: "quote"
                    };

                    const notificationIds = revision.notifications.map(note => note.notificationId);

                    apiCall('quotesAndNotifications/getUsersByRole', userRoleData).then( res => {
                        //email notifications go here
                        res.data.forEach( user => {
                            let Id = (Math.floor(Math.random() * 100000)).toString();
                            while( notificationIds.includes(Id) ){
                                Id = (Math.floor(Math.random() * 100000)).toString();
                            }

                            revision.notifications.push(
                                generateNotificationObj("Message", "quote", Id, user)
                            );
                        });

                        apiCall('quotesAndNotifications/putQuote', freshQuote).then( res => {
                            if( res.data ){
                                const apiFetchData = prepareQuoteFilterData(quoteFilters, view, credentials.userId);
                                if( view === 'quotes' ){
                                    // Refetch the updated quote from server to ensure fresh data
                                    apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( refetchRes => {
                                        const refetchedQuote = filterQuoteObjectsByInputDate( refetchRes.data )[0];
                                        if( refetchedQuote ){
                                            dispatch( updateQuotesArray( refetchedQuote ) );
                                        }
                                        dispatch( setModification( { field: 'clear'} ) );
                                        dispatch( setLoadingStatus( {field: 'approveWithChange', value: ''} ) );
                                    }).catch(() => {
                                        dispatch( setModification( { field: 'clear'} ) );
                                        dispatch( setLoadingStatus( {field: 'approveWithChange', value: ''} ) );
                                    });
                                } else {
                                    //dispatch( getNotifications( apiFetchData ) );
                                    dispatch( getAllNotifications( apiFetchData ) ).then(() => {
                                        dispatch( setModification( { field: 'clear'} ) );
                                        dispatch( setLoadingStatus( {field: 'approveWithChange', value: ''} ) );
                                    }).catch(() => {
                                        dispatch( setModification( { field: 'clear'} ) );
                                        dispatch( setLoadingStatus( {field: 'approveWithChange', value: ''} ) );
                                    });
                                }
                            } else {
                                dispatch( setLoadingStatus( {field: 'approveWithChange', value: ''} ) );
                            }
                        }).catch(() => {
                            dispatch( setLoadingStatus( {field: 'approveWithChange', value: ''} ) );
                        });

                    }).catch(e => {
                        console.log(e);
                        dispatch( setLoadingStatus( {field: 'approveWithChange', value: ''} ) );
                    });
                }
            }
        }).catch(() => {
            dispatch( setLoadingStatus( {field: 'approveWithChange', value: ''} ) );
        });
    }

    const createSuggestion = () =>{
        dispatch( setLoadingStatus( {field: 'putSuggestion', value: 'loading'} ) );
        let suggestion = modification;
        const suggestionObj = {
            userName: credentials.userName,
            categories: suggestion.categories,
            suggestion: suggestion.content,
            timestamp: createTimeStamp()
        };

        apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( res => {
        //getFreshQuotes(quoteFilters, view, credentials.userId).then( res => { //get latest quote data to help ensure data integrity
            //let quoteObjArr = filterQuoteObjectsByInputDate( res.data );
            //const freshQuote = quoteObjArr.find( quote => quote.quoteId === activeQuote.quoteId );
            const freshQuote = filterQuoteObjectsByInputDate( res.data )[0];
            if( freshQuote ){
                const revision = freshQuote.quote.find( rev => rev.revisionNumber === activeQuoteInfo.revisionNumber );
                if( revision ){
                    revision.suggestions.push(suggestionObj);
                    const userRoleData = {
                        app: "hdmi",
                        userType: "Quoter",
                        role: "quote"
                    };
                    const notificationIds = revision.notifications.map(note => note.notificationId);
                    apiCall('quotesAndNotifications/getUsersByRole', userRoleData).then( res => {
                        //email notifications go here
                        res.data.forEach( user => {
                            let Id = (Math.floor(Math.random() * 100000)).toString();
                            while( notificationIds.includes(Id) ){
                                Id = (Math.floor(Math.random() * 100000)).toString();
                            }
                            revision.notifications.push(
                                generateNotificationObj("Message", "quote", Id, user)
                            );
                        });

                        apiCall('quotesAndNotifications/putQuote', freshQuote).then( res => {
                            if( res.data ){
                                dispatch( setLoadingStatus( {field: 'putSuggestion', value: 'complete'} ) );
                                const apiFetchData = prepareQuoteFilterData(quoteFilters, view, credentials.userId);
                                if( view === 'quotes' ){
                                    //dispatch( getQuotes( apiFetchData ) );
                                    dispatch( updateQuotesArray( freshQuote ) );
                                } else {
                                    //dispatch( getNotifications( apiFetchData ) );
                                    dispatch( updateNotificationsArray( freshQuote ) );
                                }
                                dispatch( setModification( { field: 'clear'} ) );
                                setTimeout(()=>{
                                    dispatch( setLoadingStatus( {field: 'putSuggestion', value: ''} ) );
                                }, 4000);
                            }
                        });
                    }).catch(e => {
                        console.log(e);
                        dispatch( setLoadingStatus( {field: 'putSuggestion', value: 'rejected'} ) );
                        setTimeout(()=>{
                            dispatch( setLoadingStatus( {field: 'putSuggestion', value: ''} ) );
                        }, 4000);
                    });
                }
            }
        }).catch(e => {
            console.log(e);
            dispatch( setLoadingStatus( {field: 'putSuggestion', value: 'rejected'} ) );
            setTimeout(()=>{
                dispatch( setLoadingStatus( {field: 'putSuggestion', value: ''} ) );
            }, 4000);
        });
    }

    const uploadUnfinishedAuth = () =>{
        if( unfinishedAuthUpload.files.length > 0 ){
            apiCall('quotesAndNotifications/getSingleQuote',{quoteId: activeQuote.quoteId}).then( res => {
                //getFreshQuotes(quoteFilters, view, credentials.userId).then( res => { //get latest quote data to help ensure data integrity
                //let quoteObjArr = filterQuoteObjectsByInputDate( res.data );
                //const freshQuote = quoteObjArr.find( quote => quote.quoteId === activeQuote.quoteId );
                const freshQuote = filterQuoteObjectsByInputDate( res.data )[0];
                if( freshQuote ){
                    const revision = freshQuote.quote.find( rev => rev.revisionNumber === activeQuoteInfo.revisionNumber );
                    if( revision ){
                        const fileInputObjects = unfinishedAuthUpload.files.map(file => { //get input elements
                            return (
                                {
                                    id: file.id, //id is the flagId, fileId is the input element id
                                    element: document.getElementById(file.fileId),
                                    url: ''
                                }
                            );
                        });

                        const fileUploadRequests = fileInputObjects.map( inputObj => { //create api calls for the objects
                            let formData = new FormData();
                            formData.append('uploadBlob', inputObj.element.files[0]);
                            const uploadData = {
                                uploadData: formData
                            };
                            return (
                                apiCall('quotesAndNotifications/authorizationUpload', uploadData)
                                //apiCall('quotesAndNotifications/authorizationUpload', formData)
                            );
                        });

                        Promise.all( fileUploadRequests ).then( responses => {
                            responses.forEach( (res, i) => {
                                if( res.data.success ){
                                    fileInputObjects[i].url = res.data.url;
                                } else {
                                    fileInputObjects[i].url = 'ERROR';
                                }
                            });

                            fileInputObjects.forEach( uploadObj => { //loop through file input objects
                                let approvedFlag = revision.flags.find( revFlag => revFlag.id === uploadObj.id ); //get actual flag object in quote
                                if( approvedFlag ){
                                    approvedFlag.approvedBy.proofOfAuthorization = uploadObj.url;
                                }
                            });

                            apiCall('quotesAndNotifications/putQuote', freshQuote).then( res => {
                                if( res.data ){
                                    //const apiFetchData = prepareQuoteFilterData(quoteFilters, view, credentials.userId);
                                    setTimeout(()=>{
                                        const apiFetchData = prepareQuoteFilterData(quoteFilters, view, credentials.userId);
                                        if( view === 'quotes' ){
                                            //dispatch( getQuotes( apiFetchData ) );
                                            dispatch( updateQuotesArray( freshQuote ) );
                                        } else {
                                            //dispatch( getNotifications( apiFetchData ) );
                                            dispatch( updateNotificationsArray( freshQuote ) );
                                        }
                                        dispatch( setUnfinishedAuthUpload( { actionType: 'clear_all' } ) );
                                    }, 1000);
                                }
                            });

                        }).catch(e => console.log(e));
                    }
                }
            });
        }
    }

    const handlePrintQuote = () =>{
        dispatch( setLoadingStatus( {field: 'printQuote', value: 'loading'} ) );
        //apiCall('quotesAndNotifications/printQuote', {quoteId: activeQuote.quoteId}).then( response => {
        apiCall('quotesAndNotifications/printQuote', {quote: activeQuote}).then( response => {
            console.log(response);
            if( response.data.pdf ){
                let pdfByteCharacters = atob(response.data.pdf); //convert base64 encoded string
                let charCodes = new Array(pdfByteCharacters.length);
                for(let i=0;i<pdfByteCharacters.length;i++){
                    charCodes[i] = pdfByteCharacters.charCodeAt(i);
                }
                let unicodeByteArray = new Uint8Array(charCodes);
                let pdfBlob = new Blob([unicodeByteArray], {type:'application/pdf'});
                if(window.navigator && window.navigator.msSaveOrOpenBlob){
                    let f_name = activeQuote.quoteNumber + "_" + activeQuote.quote[0].timestamp.replace(/\//g, '-') + ".pdf";
                    dispatch( setLoadingStatus( {field: 'printQuote', value: ''} ) );
                    window.navigator.msSaveOrOpenBlob(pdfBlob,f_name);
                }else{
                    let fileURL = window.URL.createObjectURL(pdfBlob);
                    dispatch( setLoadingStatus( {field: 'printQuote', value: ''} ) );
                    window.open(fileURL);
                }
            }
        }).catch(e => {
            console.log(e);
            dispatch( setLoadingStatus( {field: 'printQuote', value: 'rejected'} ) );
        });
    }

    const categoriesListItems = categories.map( category => {
        let checked = modification.categories.includes( category );
        return (
            <li className="suggestion_category_li" key={ category }>
                <Input
                    type="checkbox"
                    handleChange={ (e) => handleModificationChange(e, 'categories') }
                    label={ category }
                    name={ category }
                    checked={ checked }
                    value={ category }
                />
            </li>
        );
    });
    let modificationSuccessMessage = canSuggest ? "Suggestion" : "Required change";
    if( loadingStatus.putSuggestion === 'rejected' ){
        modificationSuccessMessage = "There was a problem creating the " + modificationSuccessMessage.toLowerCase() + ".";
    } else if( loadingStatus.putSuggestion === 'complete' ){
        modificationSuccessMessage += " was successfully created!";
    }
    return (
        <div>
            {
                canApprove &&
                <button
                    className="quote_action_button"
                    onClick={ () => approveQuote()}
                >
                { approveIcon } <span className="quote_action_button_text">Approve</span>
                </button>
            }
            {
                canApproveOnBehalf &&
                <Accordion
                    contentDescription="Approve On Behalf"
                    headContent={
                        <div className="action_button_accordion_header">
                            { approveIcon }
                            <span className="quote_action_button_text">Approve On Behalf</span>
                        </div>
                    }
                    isTopAccordion={ false }
                    contentClass="side_panel_accordion_content"
                >
                    <div className="action_content_wrapper">
                        <div className="action_text_container">
                            {
                                filteredFlags.map((flag, i) => {
                                    console.log(flag);
                                    let label = `${flag.chainOfCommand[0].role} (flag #${i+1})`;
                                    return (
                                        <div className="approve_on_behalf_checkboxes" key={flag.id}>
                                            <Input
                                                type="checkbox"
                                                handleChange={ (e) => handleApproveOnBehalf(e, 'flags', flag) }
                                                label={ label }
                                                name={ flag.types.category }
                                                // checked={ checked }
                                                value={ flag.id }
                                            />
                                        </div>
                                    );
                                })
                            }
                            {
                                approveOnBehalfData.flags.map((flag, i) => {
                                    let flagIndex = filteredFlags.findIndex( filteredFlag => filteredFlag.id === flag.id );
                                    return (
                                        <Input
                                            key={flag.id}
                                            type="file"
                                            labelClass="action_text_area_label"
                                            label={ `flag #${flagIndex + 1}` }
                                            inputId={ `flag_${flagIndex + 1}` }
                                            handleChange={ (e) => handleApproveOnBehalf(e, 'files', { id: flag.id, fileId: e.target.id } ) }
                                            handleClear={ (inputId) => handleApproveOnBehalf(inputId, 'clear_files', { id: flag.id, fileId: inputId }) }
                                        />
                                    );
                                })
                            }
                        </div>
                        <div className="action_submit_button_container">
                            <button
                                className="action_submit_button approve_on_behalf_submit"
                                onClick={ () => approveOnBehalf() }
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </Accordion>
            }
            {
                (canSuggest || canApprove) &&
                <Accordion
                    contentDescription={ canSuggest ?  "Suggest Modification" : "Approve With Change"}
                    headContent={
                        <div className="action_button_accordion_header">
                            { canSuggest ? suggestionIcon : cautionIcon }
                            <span className="quote_action_button_text">
                                { canSuggest ?  "Suggest Modification" : "Approve With Change" }
                            </span>
                        </div>
                    }
                    isTopAccordion={ false }
                    contentClass="side_panel_accordion_content"
                    disabled={ loadingStatus.putSuggestion === 'complete' || loadingStatus.putSuggestion === 'rejected' }
                >
                    <div className="action_content_wrapper">
                        {
                            (loadingStatus.putSuggestion === 'rejected' || loadingStatus.putSuggestion === 'complete') &&
                            <div className="suggestion_confirmation_div">
                                <span className="suggestion_confirmation_message">{ modificationSuccessMessage }</span>
                            </div>
                        }
                        <div className="suggestion_list_container">
                            <label className="action_text_area_label suggestion_categories_label">
                                { canSuggest ? "Suggestion" : "Change" } Categories
                            </label>
                            <ul className="suggestion_category_list">
                                { categoriesListItems }
                            </ul>
                        </div>
                        <div className="action_text_container">
                            <Input
                                type="textarea"
                                handleChange={ (e) => handleModificationChange(e, 'content') }
                                label={ canSuggest ? "Suggestion" : "Required Changes" }
                                name={ canSuggest ? "Suggestion" : "Required Changes" }
                                inputClass="action_text_area"
                                labelClass="action_text_area_label"
                                value={ modification.content }
                            />
                        </div>
                        <div className="action_submit_button_container">
                            <button
                                className={
                                    canSuggest ? "action_submit_button suggestion_submit" : "action_submit_button approve_with_change_submit"
                                }
                                onClick={ () => canSuggest ? createSuggestion() : approveWithChange() }
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </Accordion>
            }
            {
                canApprove &&
                <Accordion
                    contentDescription="Deny Quote"
                    headContent={
                        <div className="action_button_accordion_header">
                            { denyIcon }
                            <span className="quote_action_button_text">Deny</span>
                        </div>
                    }
                    isTopAccordion={ false }
                    contentClass="side_panel_accordion_content"
                >
                    <div className="action_content_wrapper">
                        <div className="action_text_container">
                            <Input
                                type="textarea"
                                handleChange={ (e) => dispatch( setUnsavedDenialReason( e.target.value ) ) }
                                label="Reason for Denial"
                                name="denial"
                                inputClass="action_text_area"
                                labelClass="action_text_area_label"
                                value={ denialReason }
                            />
                        </div>
                        <div className="action_submit_button_container">
                            <button
                                className="action_submit_button deny_submit"
                                onClick={ () => denyQuote() }
                            >
                                Deny Quote
                            </button>
                        </div>
                    </div>
                </Accordion>
            }
            {
                unfinishedFlags &&
                <Accordion
                    contentDescription="Authorization Upload"
                    headContent={
                        <div className="action_button_accordion_header">
                            { uploadIcon }
                            <span className="quote_action_button_text">Authorization Upload</span>
                        </div>
                    }
                    isTopAccordion={ false }
                    contentClass="side_panel_accordion_content"
                >
                    <div className="action_content_wrapper">
                        <div className="action_text_container">
                            {
                                unfinishedFlagsArray.map((flag, i) => {
                                    let approveUser = '';
                                    flag.chainOfCommand.forEach( command => {
                                        if( approveUser === '' ){
                                            approveUser = command.userName;
                                        } else {
                                            approveUser += `, ${command.userName}`;
                                        }
                                    });
                                    return (
                                        <Input
                                            key={flag.id}
                                            type="file"
                                            labelClass="action_text_area_label"
                                            label={ `(${approveUser}): ${flag.types.meta.flagDescription}` }
                                            inputId={ `flag_${flag.id}` }
                                            handleChange={ (e) => handleUnfinishedFlags('add', { id: flag.id, fileId: e.target.id } ) }
                                            handleClear={ (inputId) => handleUnfinishedFlags('clear', { id: flag.id, fileId: inputId }) }
                                        />
                                    );
                                })
                            }
                        </div>
                        <div className="action_submit_button_container">
                            <button
                                className="action_submit_button auth_upload_submit"
                                onClick={ () => uploadUnfinishedAuth() }
                            >
                                Upload Evidence
                            </button>
                        </div>
                    </div>
                </Accordion>
            }
            {
                canPrint &&
                <button
                    className="quote_action_button"
                    onClick={ handlePrintQuote }
                >
                { printIcon } <span className="quote_action_button_text">Print</span>
                </button>
            }
            {
                canExport &&
                <CsvDownload activeQuote={ props.activeQuote } />
            }
            {
                canRevise &&
                <button
                    className="quote_action_button"
                    onClick={ () => {
                        dispatch( openQuoteRevision({ quote: activeQuote }) );
                        dispatch( setCurrentPage( "Create Quote" ) );
                    }}
                >
                { createIcon } <span className="quote_action_button_text">Create Revision</span>
                </button>
            }
            {
                (pendingFlags.length > 0 || approvedFlags.length > 0) &&
                <>
                <h3 className="side_panel_title">
                    Flags
                </h3>
                {
                    pendingFlags.length > 0 &&
                    <>
                    <h4 className="flags_section_title">
                        Pending
                    </h4>
                    <ol className="flags_list">
                        {
                            pendingFlags.map(flag => <li key={flag.id}><span>{ flag.types.meta.flagDescription }</span></li>)
                        }
                    </ol>
                    </>
                }
                {
                    approvedFlags.length > 0 &&
                    <>
                    <h4 className="flags_section_title">
                        Approved
                    </h4>
                    <ol className="flags_list flags_list_approved">
                        {
                            approvedFlags.map(flag => <li key={flag.id}><span>{ flag.types.meta.flagDescription }</span></li>)
                        }
                    </ol>
                    </>
                }
                </>
            }
            {
                !(filteredFlags.length > 0 || canExport || canPrint || unfinishedFlags || canSuggest || canApprove || canApproveOnBehalf) &&
                <p style={{textAlign: 'left'}}>
                    { actionsMessage(quoteStatus) }
                </p>
            }
        </div>
    );
}

export default Actions;
